import React, { useState, useEffect, useMemo } from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useSelector, useDispatch } from 'react-redux';
import {
  filterData,
  updateFilterField,
} from '../redux/actions';

// ✅ Merged DocTypeFilter component
const DocTypeFilter = ({ label, options, field, value }) => {
  const dispatch = useDispatch();


  const selectedOption = useMemo(() => {
    if (!value || !Array.isArray(options) || options.length === 0) return null;

    // For projId, match by id
    if (field === 'projId') {
      return options.find(opt => opt.id === value) || null;
    }

    // For other fields, match by name
    return options.find(opt => opt.name === value) || null;
  }, [options, value, field]);

  return (
    <Autocomplete
      id="combo-box-demo"
      margin="normal"
      options={options}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={(e, newValue) => {
        if(newValue) {
          const value = field === 'projId' ? newValue.id : newValue.name;
          dispatch(updateFilterField(field, value));
        }
      }}
      renderInput={(params) => <TextField {...params} label={label} style={{ top: 16 }} />}
    />
  );
};

const AdvancedSearch = () => {
  const dispatch = useDispatch();

  // Get values from Redux store
  const filters = useSelector((state) => state.filters);
  const uniqueNeighborhood = useSelector((state) => state.defaultDropdownOptions.uniqueNeighborhood);
  const uniqueDocumentTypes = useSelector((state) => state.defaultDropdownOptions.uniqueDocumentTypes);
  const uniqueProjectNames = useSelector((state) => state.defaultDropdownOptions.uniqueProjectNames);

  const [startDate, setStartDate] = useState(filters.startDate ? new Date(filters.startDate) : null);
      const [endDate, setEndDate] = useState(filters.endDate ? new Date(filters.endDate) : null);
  useEffect(() => {
      dispatch(updateFilterField('filters', filters));
  ;
  },[startDate, endDate, filters.docTypeValue, filters.neighborhoodValue, filters.projId]);
  useEffect(() => {
    if (startDate instanceof Date && !isNaN(startDate.getTime())) {
      dispatch(updateFilterField('startDate', startDate));
    }
  }, [startDate]);
  useEffect(() => {
    if (endDate instanceof Date && !isNaN(endDate.getTime())) {
      dispatch(updateFilterField('endDate', endDate));
    }
  }, [endDate]);
  const handleSearch = () => {
    dispatch(updateFilterField({
      ...filters,
      startDate: startDate,
      endDate: endDate,
      page:1,
      pageMarker: {},
    }));
  };

  const handleClear = () => {
    window.location.reload(false);
  };

  return (
    <Toolbar style={{ marginBottom: 25 }}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around" spacing={3}>
          <Grid item xs={6} md={6} lg={2}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              label="Start Date"
              value={startDate}
              onChange={(date) => setStartDate(date)}
              KeyboardButtonProps={{
                'aria-label': 'change start date',
              }}
              style={{ width: '100%' }}
            />
          </Grid>
          <Grid item xs={6} md={6} lg={2}>
            <KeyboardDatePicker
              margin="normal"
              label="End Date"
              format="MM/dd/yyyy"
              value={endDate}
              onChange={(date) => setEndDate(date)}
              KeyboardButtonProps={{
                'aria-label': 'change end date',
              }}
              style={{ width: '100%' }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <DocTypeFilter
              label="Documents"
              options={uniqueDocumentTypes}
              field="docTypeValue"
              value={filters.docTypeValue}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <DocTypeFilter
              label="Projects and Plans"
              options={uniqueProjectNames}
              field="projId"
              value={filters.projId}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={2}>
            <DocTypeFilter
              label="Neighborhoods"
              options={uniqueNeighborhood}
              field="neighborhoodValue"
              value={filters.neighborhoodValue}
            />
          </Grid>
          <Grid item xs={6} md={2} lg={1}>
            <Button
              color="primary"
              variant="outlined"
              onClick={handleClear}
              style={{ height: 45, marginTop: 20 }}
            >
              Clear
            </Button>
          </Grid>
          <Grid item xs={6} md={2} lg={1}>
            <Button
              color="primary"
              variant="outlined"
              onClick={handleSearch}
              style={{ height: 45, marginTop: 20 }}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Toolbar>
  );
};

export default AdvancedSearch;
